import React, { useRef } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';

import svgIconCheck from '@common/assets/svg/icon-check.svg';
import { COLOR_BLUE_007, COLOR_RED, COLOR_TURQUOISE } from '@common/assets/styles/colors';

const CheckboxSC = styled.div`
  display: flex;
  justify-content: flex-start;

  input {
    display: none;
  }

  &.has-error {
    .checkbox {
      border: 1px solid ${COLOR_RED};
    }
  }

  .checkbox {
    cursor: pointer;

    min-width: 20px;
    height: 20px;
    border-radius: 6px;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${COLOR_BLUE_007};

    margin-right: 8px;

    svg {
      g {
        stroke: ${COLOR_TURQUOISE};
      }
    }
  }
`;

type TCheckboxProps = {
  checked: boolean;
  hasError?: boolean;
  className?: string;
  children?: React.ReactNode;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Checkbox: React.FC<TCheckboxProps> = ({
  checked,
  hasError = false,
  className = '',
  children = null,
  ...rest
}: TCheckboxProps) => {
  const innerCheckboxRef = useRef(null);

  const cNames = classNames(className, { 'has-error': hasError });

  const handleClick = () => {
    if (innerCheckboxRef && innerCheckboxRef.current) {
      innerCheckboxRef.current.click();
    }
  };
  return (
    <CheckboxSC className={cNames}>
      <input ref={innerCheckboxRef} type="checkbox" {...rest} />
      <div className="checkbox" onClick={(e) => handleClick()}>
        {checked ? <SVG src={svgIconCheck} /> : null}
      </div>
      <div>{children}</div>
    </CheckboxSC>
  );
};

export default Checkbox;
